import React from 'react';
import TabOfDataTable from '../../../../Elements/DataTable/TabOfDataTable';
import MyOfficeAssignmentItem from '../../../../Domain/MyOfficeAssignmentItem';
import AssignmentService from '../../../../Services/AssignmentService';
import MyOfficeAssignmentSearchParams from './MyOfficeAssignmentSearchParams';

export default class MyOfficeAssignmentAdmin extends React.Component {
  static defaultProps = {
    type: '',
    projectId: 0,
    completedDate: '',
  };

  constructor(props) {
    super(props);

    this.state = {
      searchItem: new MyOfficeAssignmentSearchParams(),
    };
    this.state.searchItem.Type = this.props.type;
    this.state.searchItem.AsCfId = this.props.projectId;
    this.state.searchItem.CompletedDate = this.props.completedDate;
  }

  componentDidUpdate(prevProps) {
    if (this.props.type !== prevProps.type) {
      this.setState({
        searchItem: {
          ...this.state.searchItem,
          Type: this.props.type,
        },
      });
    }
  }

  render() {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          type={MyOfficeAssignmentItem}
          serviceFunction={AssignmentService.GetMyOfficeAssignmentsBySearching}
          convertDBItemsFunction={AssignmentService.ConvertMyOfficeAssignmentDBItems}
          searchItem={this.state.searchItem}
          errorCode='MOAA31'
        />
      </div>
    );
  }
}
